module.exports = __webpack_public_path__ + "static/media/velour10B.99111163.jpg";